const React = require('react');

const Content = require('./Content.jsx');
const _Image = require('./Image.jsx');
const Token = require('../utility/Token.jsx');
const TypeConfig = require('./TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region CONTAINER

function ItemContainer(props) {
    let spacer;
    let styleContainer = { verticalAlign: 'top' };
    if (props.blockProps) {
        const borderProps = props.borderProps || {};
        styleContainer = { ...styleContainer, ...borderProps };
        if (props.index != props.count - 1) {
            const style = { ...borderProps };
            if (styleContainer.borderLeftWidth) {
                style.borderLeftColor = styleContainer.borderLeftWidth
            }
            if (props.blockProps.itemSpacing && !Utilities.isNullOrWhitespace(props.blockProps.itemSpacing.value)) {
                style.paddingTop = `${props.blockProps.itemSpacing.value / 2.0}${props.blockProps.itemSpacing.unit}`;
            }
            if (props.blockProps.itemSeparatorSize && !Utilities.isNullOrWhitespace(props.blockProps.itemSeparatorSize.value)) {
                style.borderTopColor = '#e9e9e9';
                style.borderTopStyle = 'solid';
                style.borderTopWidth = `${props.blockProps.itemSeparatorSize.value}${props.blockProps.itemSeparatorSize.unit}`;

                if (!Utilities.isNullOrWhitespace(props.blockProps.itemSeparatorColor)) {
                    style.borderTopColor = props.blockProps.itemSeparatorColor;
                }
            }
            spacer = (
                <>
                    <tr style={props.builder && !props.editor ? { pointerEvents: 'none' } : undefined}><td style={{ ...borderProps, paddingTop: style.paddingTop }}></td></tr>
                    <tr style={props.builder && !props.editor ? { pointerEvents: 'none' } : undefined}><td style={style}></td></tr>
                </>
            )
        }
    }
    let content = (
        <>
            <tr style={props.builder && !props.editor ? { pointerEvents: 'none' } : undefined}>
                <td style={styleContainer}>
                    {props.content}
                    {
                        props.builder &&
                        !props.editor &&
                        (!props.content || props.content.length == 0) &&
                        Utilities.Builder.emptyBlockPlaceholder()
                    }
                </td>
            </tr>
            {spacer}
        </>
    )
    if (!props.builder || props.editor) {
        content = (
            <table
                border="0"
                cellPadding="0"
                cellSpacing="0"
                className="pageBreakInsideAvoid"
                style={{ width: '100%' }}
                width="100%">
                <tbody>
                    {content}
                </tbody>
            </table>
        );
    }
    return content;
}

// #endregion CONTAINER

// #region IMAGE

function Image(props) {
    let data = props.itemData || props.data || {};
    if (data.Inventory && props.index < data.Inventory.length) {
        data = data.Inventory[props.index];
    }
    return <_Image.Component {...props} alt={data.Title} image={data.Image} imageUrl={data.ImageUrl} url={data.Url} />
}

// #endregion IMAGE

// #region META

function _Meta(props) { return <Content.Value {...props} value={props.content} /> }
const Meta = Token.withContentTokenParsing(_Meta, {}, Token.TypeParsing.inventory);
const TypeConfigMeta = {
    defaultDesign: `<p><span token="${Token.Artist.Name}">{${Token.Artist.Name}("before":"","after":"")}</span></p><p><span style="display:inline;font-style:italic;" token="${Token.Inventory.Title}">{${Token.Inventory.Title}("before":"","after":"")}</span><span style="display:inline;" token="${Token.Inventory.Edition}">{${Token.Inventory.Edition}("before":" (","after":")")}</span><span style="display:inline;" token="${Token.Date}">{${Token.Date}("before":", ","after":"")}</span></p><p><span token="${Token.Inventory.Medium}">{${Token.Inventory.Medium}("before":"","after":"")}</span></p><p><span token="${Token.Inventory.Dimensions}">{${Token.Inventory.Dimensions}("before":"","after":"")}</span></p><p><span token="${Token.Inventory.AlternateDimensions}">{${Token.Inventory.AlternateDimensions}("before":"","after":"")}</span><p><span token="${Token.Inventory.SKU}">{${Token.Inventory.SKU}("before":"SKU: ","after":"")}</span></p><p><span token="${Token.Inventory.Number}">{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}</span></p>`,
    panel: {
        block: (design) => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Design item meta here',
                        label: 'Item Meta Design',
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: design || TypeConfigMeta.defaultDesign
                    }
                ]
            };
        },
        style: () => TypeConfig.panel.layoutStyleV2('style', 'Layout')
    }
};

// #endregion META

module.exports = {
    Container: {
        Component: ItemContainer
    },
    Image: {
        Component: Image,
        TypeConfig: _Image.TypeConfigV2
    },
    Meta: {
        Component: Meta,
        TypeConfig: TypeConfigMeta
    }
}